import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, useToggle } from '@pella/sash-framework';

const GreenskyFinancing = ({ data }) => {
	const { open, onToggleClick } = useToggle();

	if (!data) return null;

	return (
		<div
			className='greensky-financing'
			data-testid='greensky-financing'
		>
			{data.description && (
				<div
					className='text-center [&>div]:inline-block'
					dangerouslySetInnerHTML={{ __html: data.description }}
				/>
			)}

			<div className='text-center'>
				<Button
					color='tertiary-alt'
					onClick={onToggleClick}
					className='mt-1'
				>
					See Terms & Conditions
				</Button>
			</div>

			<Modal
				isOpen={open}
				onClose={onToggleClick}
				width={800}
			>
				<Modal.Header>&nbsp;</Modal.Header>
				<Modal.Content className='text-center'>{data.terms_and_conditions && <div dangerouslySetInnerHTML={{ __html: data.terms_and_conditions }} />}</Modal.Content>
			</Modal>
		</div>
	);
};

GreenskyFinancing.propTypes = {
	data: PropTypes.object,
};

export default GreenskyFinancing;
